import { Card, CardContent, CardHeader, Grid, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AccountSettingsV2FormType } from "./AccountSettingsV2Utils";
import { GaugeSheetViewMode } from "../../views/gauge-sheet-view/GaugeSheetState";
import FormCheckbox from "../forms/form-checkbox/FormCheckbox";
import { useFormContext } from "react-hook-form";
import FormRadioGroup, { FormRadioGroupRadioButton } from "../forms/form-radio-group/FormRadioGroup";
import i18n from "../../services/localization-service/i18n";


const radioButtons: FormRadioGroupRadioButton[] = [{
    label: i18n.t('liquidProd.mode.spreadsheet'),
    value: GaugeSheetViewMode.Spreadsheet
}, {
    label: i18n.t('liquidProd.mode.form'),
    value: GaugeSheetViewMode.Form
}];

export default function GaugeSheetDefaultsCard() {

    const { t } = useTranslation();
    const theme = useTheme();

    const {
        //watch,
        getValues,
        setValue
    } = useFormContext<AccountSettingsV2FormType>();



    function onShowDeviceChange(checked: boolean) {

        const tankChecked = getValues('gaugeSheetShowTanks');

        if (!checked && !tankChecked) {
            setValue('gaugeSheetShowTanks', true, {shouldDirty: true});
        }

    }

    function onShowTanksChange(checked: boolean) {
        const deviceChecked = getValues('gaugeSheetShowDevice');

        if (!checked && !deviceChecked) {
            setValue('gaugeSheetShowDevice', true, {shouldDirty: true});
        }
        
    }


    return (
        <Card
            raised={true}
            sx={{
                flex: "0 0 auto",
                margin: theme.spacing(1),
                padding: theme.spacing(2)
            }}
        >
            <CardHeader
                    sx={{
                        padding: 1
                    }}
                    title={t('views.gaugesheet')}
                     slotProps={{
                         title: { 
                            sx: {
                                fontWeight: "bold", 
                            },
                            variant: 'h5', 
                        }
                     }}
                />
            <CardContent
                sx={{
                    padding: 1,
                    paddingBottom: theme => `${theme.spacing(1)} !important`
                }}
            >

                <Grid container spacing={2}>

                    <Grid size={{ xs: 12 }}>
                        <Typography sx={{
                            fontWeight: 'bold'
                        }}>
                            {t('profile.display')}
                        </Typography>

                        <FormRadioGroup label=''
                            direction='row'
                            name='gaugeSheetViewMode'
                            radioButtons={radioButtons} 
                        />

                    </Grid>
                    
                    <Grid size={{ xs: 12 }}>

                    <FormCheckbox
                        name="gaugeSheetShowDevice"
                        label={t("liquidProd.showDevice")}
                        onChange={(_ev, checked) => onShowDeviceChange(checked)}
                    />

                    <FormCheckbox
                        name="gaugeSheetShowTanks"
                        label={t("liquidProd.showTanks")}
                        onChange={(_ev, checked) => onShowTanksChange(checked)}

                    />

                    </Grid>


                    
                </Grid>

           </CardContent>
        </Card>
    );
}